import { LocaleAllow } from '../..//types/IHeader';

export interface FallBackImage {
  height: number;
  url: string;
  src: string;
  width: number;
}

export type PostMeta = {
  fallbackSeoImage?: FallBackImage;
  fallbackVideoImage?: FallBackImage;
};

const getImage = (image: any) => {
  const _image = {
    url: image?.url,
    src: image?.url,
    width: image?.width,
    height: image?.height,
  };
  return _image;
};

export const getPostMeta = (data: any, locale: LocaleAllow): PostMeta => {
  const globalSeo = data[`seo${locale}`]?.globalSeo;

  const fallbackVideoImage = getImage(
    data[`setting${locale}`]?.defaultVideoThumbnail,
  );
  const fallbackSeoImage = getImage(globalSeo?.fallbackSeo?.image);
  return {
    fallbackSeoImage,
    fallbackVideoImage,
  };
};

export const getCookie = (name: string) => {
  if (typeof window === 'undefined') return null;
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null; // Return null if the cookie doesn't exists
}